export const formatMixpanelKeys = (obj) => {
    const formattedObject = {};

    Object.keys(obj).forEach((key) => {
        const formattedKey = key
            .replace(/([a-z])([A-Z])/g, '$1 $2') // add space before capital letters
            .replace(/^./, (str) => str.toUpperCase()); // capitalize first letter

        formattedObject[formattedKey] = obj[key];
    });

    return formattedObject;
};
